export const GET_PROJECT_SECTIONS = "GET_PROJECT_SECTIONS";
export const GET_PROJECT_SECTION_BY_ID = "GET_PROJECT_SECTION_BY_ID";
export const UPDATE_PROJECT_SECTION = "UPDATE_PROJECT_SECTION";
export const DELETE_PROJECT_SECTION = "DELETE_PROJECT_SECTION";
export const CREATE_PROJECT_SECTION = "CREATE_PROJECT_SECTION";
